import React, { useState, useEffect } from "react";
import { Fade } from "react-slideshow-image";
import { HashLink as Link } from "react-router-hash-link";

// Hero component
const Hero = ({data, heroNfts, campaign, previewCard}) => {
  
  // State variables for countdown timer and campaign status
  const [months, setMonths] = useState(0);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [campaignStatus, setCampaignStatus] = useState("");


  // Function to calculate and set the countdown timer based on campaign dates
  const getCampaignDates = () => {
    const countdownEnddate = new Date(data.ends_on).getTime();
    const countdownStartdate = new Date(data.starts_on).getTime();
    const now = new Date().getTime();
    let diff = 0;

    if (countdownStartdate > now) {
      diff = countdownStartdate - now;
      setCampaignStatus("starts in");
      calculateTimer(diff);
    } else if (countdownStartdate < now && countdownEnddate > now) {
      diff = countdownEnddate - now;
      setCampaignStatus("ends in");
      calculateTimer(diff);
    } else if (countdownEnddate !== 0 && countdownEnddate < now) {
      setCampaignStatus("minting has ended");
      setHours("00");
      setMinutes("00");
      setSeconds("00");
    } else if (countdownEnddate === 0 && countdownStartdate === 0) {
      setCampaignStatus("minting has no end date");
      setHours(null);
    }
  };

  // Function to convert time difference into months, days, hours, minutes, and seconds
  const calculateTimer = (diff) => {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;

    setMonths(Math.floor(diff / month));
    setDays(Math.floor((diff % month) / day));
    setHours(Math.floor((diff % day) / hour));
    setMinutes(Math.floor((diff % hour) / minute));
    setSeconds(Math.floor((diff % minute) / second));
  };

  // useEffect to update the timer every second
  useEffect(() => {
    const interval = setInterval(() => {
      getCampaignDates();
    }, 1000);
    return () => clearInterval(interval);
  }, [getCampaignDates]);

  // State to manage beta alert text
  const [text, setText] = useState();

  // Setting up initial beta alert state
  useEffect(() => {
    if (sessionStorage.getItem("beta") === null) {
      setBeta();
    } else {
      setText(JSON.parse(sessionStorage.getItem("beta")));
    }
  }, []);

  // Function to change beta alert state and save it to session storage
  const setBeta = () => {
    setText({
      name: "The project is in BETA.",
      style: "beta-alert-text-pre",
    });
    requestAnimationFrame(() => {
      const beta = { name: "BETA", style: "beta-alert-text-post" };
      setText(beta);
      sessionStorage.setItem("beta", JSON.stringify(beta));
    }, 10000);
  };

  // Function to reset beta alert on mouse hover
  const reset = () => {
    setBeta();
  };

  // Function to display NFT content if available
  const getContent = () => {
    if (heroNfts && heroNfts.length) {
      return heroNfts.map((card, index) => (
        <div className="hero__nft-wrapper" key={index}>
          <div className="hero__nft-img-box">
            <img className="hero__nft-img" src={card.image} alt="" />
          </div>
          <div>
            <p
              className="hero__nft-name"
              style={{ color: data.web_main_color }}
            >
              {card.name}
            </p>
            <p
              className="hero__nft-owner"
              style={{ color: data.web_main_color }}
            >
              {card.currentOwner.length > 0
                ? `Owned by ${card.currentOwner.slice(
                  0,
                  6
                )}...${card.currentOwner.slice(card.currentOwner.length - 4)}`
                : ""}
            </p>
          </div>
        </div>
      ));
    }
    return <></>;
  };

  return (
    <>
      <span className="link_wrapper" id="home"></span>
      <div
        className="snackbar"
        style={{ backgroundColor: data.gradient_color_1 }}
      >
        {/* Campaign countdown display */}
        <div className="snackbar-countdown-container">
          <span className="snackbar-text">Campaign {campaignStatus}</span>
          {/* Display countdown months, days, hours, minutes, and seconds */}
          {/* Conditional rendering based on countdown status */}

          {campaignStatus !== "minting has ended" && (
            <>
              <div
                className="snack-box"
                style={
                  months === 0
                    ? { display: "none" }
                    : { display: "inline-block" }
                }
              >
                <span
                  className="snack-box-text"
                  style={{ color: data.gradient_color_1 }}
                >
                  {months < 10 ? "0" + months : months}
                </span>
              </div>
              <span
                className="snackbar-text"
                style={
                  months === 0
                    ? { display: "none" }
                    : { display: "inline-block" }
                }
              >
                M
              </span>
              <div
                className="snack-box"
                style={
                  days === 0 ? { display: "none" } : { display: "inline-block" }
                }
              >
                <span
                  className="snack-box-text"
                  style={{ color: data.gradient_color_1 }}
                >
                  {days < 10 ? "0" + days : days}
                </span>
              </div>
              <span
                className="snackbar-text"
                style={
                  days === 0 ? { display: "none" } : { display: "inline-block" }
                }
              >
                D
              </span>
              <div
                className="snack-box"
                style={
                  hours === null
                    ? { display: "none" }
                    : { display: "inline-block" }
                }
              >
                <span
                  className="snack-box-text"
                  style={{ color: data.gradient_color_1 }}
                >
                  {hours < 10 ? "0" + hours : hours}
                </span>
              </div>
              <span
                className="snackbar-text"
                style={
                  hours === null
                    ? { display: "none" }
                    : { display: "inline-block" }
                }
              >
                :
              </span>
              <div
                className="snack-box"
                style={
                  hours === null
                    ? { display: "none" }
                    : { display: "inline-block" }
                }
              >
                <span
                  className="snack-box-text"
                  style={
                    hours === null
                      ? {
                        display: "none",
                        color: data.gradient_color_1,
                      }
                      : {
                        display: "inline-block",
                        color: data.gradient_color_1,
                      }
                  }
                >
                  {minutes < 10 ? "0" + minutes : minutes}
                </span>
              </div>
              <span
                className="snackbar-text"
                style={
                  hours === null
                    ? { display: "none" }
                    : { display: "inline-block" }
                }
              >
                :
              </span>
              <div
                className="snack-box"
                style={
                  hours === null
                    ? { display: "none" }
                    : { display: "inline-block" }
                }
              >
                <span
                  className="snack-box-text"
                  style={
                    hours === null
                      ? {
                        display: "none",
                        color: data.gradient_color_1,
                      }
                      : {
                        display: "inline-block",
                        color: data.gradient_color_1,
                      }
                  }
                >
                  {seconds < 10 ? "0" + seconds : seconds}
                </span>
              </div>
            </>
          )}
        </div>

        <div className="snackbar-countdown-container">
          {/* Display mint count if max_count is available */}
          {data?.max_count > 0 && (
            <>
              <div className="snack-box">
                <span
                  className="snack-box-text"
                  style={{ color: data.gradient_color_1 }}
                >
                  {previewCard?.length || 0}
                </span>
              </div>
              <span className="snackbar-text">
                {campaignStatus !== "minting has ended" ? "out of" : "of"}
              </span>
            </>
          )}
          <div className="snack-box">
            <span
              className="snack-box-text"
              style={{ color: data.gradient_color_1 }}
            >
              {data?.max_count > 0 ? data?.max_count : 0}
            </span>
          </div>
          <span className="snackbar-text">
            {campaignStatus !== "minting has ended" ? "have been" : "were"}{" "}
            minted{" "}
          </span>
        </div>
      </div>

      <section
        className="hero"
        style={{
          backgroundImage: `url("data:image/svg+xml;base64,${data?.hero}")`,
        }}
      >
        <div className="hero__desktop">
          <div className="hero__box">
            <div className="hero__box-left">
              <div className="beta-alert">
                <span
                  className={text?.style}
                  style={
                    text?.name === "BETA"
                      ? {
                        color: data.web_main_color,
                        borderColor: data.web_main_color,
                      }
                      : {
                        backgroundColor: data.web_main_color,
                        borderColor: data.web_main_color,
                      }
                  }
                  onMouseEnter={() => reset()}
                >
                  {text?.name}
                </span>
              </div>
              <h1
                className="hero__title"
                style={{ color: data.web_main_color }}
              >
                {campaign?.campaign_id && data.nft_name
                  ? ` The ${data.nft_name_plural} Collection`
                  : `The NFTs Collection`}
              </h1>
               <p
                className="hero__desc"
                style={{ color: data.web_main_color }}
              >
               {campaign?.hero_page_text || "Design your own unique digital art while helping this beneficiary. We’re calling for your help!"}
              </p>
              <Link to="/preview-home/#about" smooth offset={-70} duration={500}>
                <span
                  className="hero__btn"
                  style={{ backgroundColor: data.web_main_color }}
                >
                  Find Out More
                </span>
              </Link>
            </div>
            <div className="hero__box-right">
              <Fade autoplay={true}>{getContent()}</Fade>
            </div>
          </div>
        </div>
        {/* Mobile view */}
        <div className="hero__mobile">
          <div className="hero__box">
            <h1
              className="hero__title"
              style={{ color: data.web_main_color }}
            >
              bskbkhshbks
            </h1>
            <div className="hero__nft-box">
              <Fade autoplay={true}>{getContent()}</Fade>
            </div>
            <p
              className="hero__desc"
              style={{ color: data.web_main_color }}
            >
              dfhkshk
            </p>
            <Link to="/#about" smooth offset={-70} duration={500}>
              <span
                className="hero__btn"
                style={{ backgroundColor: data.web_main_color }}
              >
                Find Out More
              </span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
